import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22807 15772"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:327.232}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970273038304">
        <path
          d="M16308 164H7086l6288 7722-6288 7722h9222l6288-7722z"
          className="fill stroke1"
          style={{
            strokeWidth: 327.232,
          }}        />
        <path
          d="M3354 164H344l6288 7722-6288 7722h3010l6288-7722z"
          className="fill stroke1"
          style={{
            strokeWidth: 327.232,
          }}        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
